// src/components/SimpleComponents/SimpleAddressZip.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleCep from './SimpleCep';
import SimpleCodigoPostal from './SimpleCodigoPostal';
import SimpleZip from './SimpleZip';
import useSubscriptionLocale from 'hooks/useSubscriptionLocale';
import { countryCodeFromLocale } from './SimpleEntityUid';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
// Universal postal-code input. Routes by countryCode, mirroring SimpleEntityUid:
//   BR -> SimpleCep           (CEP,           ViaCEP / BrasilAPI)
//   PT -> SimpleCodigoPostal  (Codigo Postal, GeoAPI.pt)
//   *  -> SimpleZip           (generic, no lookup)
// Each country component owns its mask + validation; the provider
// handleAddressZipBlur dispatches the lookup to the matching country API.
const SimpleAddressZip = ({ countryCode: countryCodeProp, ...props }) => {
  // ---------------------------------------------------------------------------
  // 1. PROPS, CONTEXTS & GLOBAL STATE
  // ---------------------------------------------------------------------------
  const { locale } = useSubscriptionLocale();
  const countryCode = (countryCodeProp || countryCodeFromLocale(locale) || '').toUpperCase();

  // ---------------------------------------------------------------------------
  // 2. UI
  // ---------------------------------------------------------------------------
  if (countryCode === 'BR') return <SimpleCep {...props} />;
  if (countryCode === 'PT') return <SimpleCodigoPostal {...props} />;
  return <SimpleZip {...props} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default SimpleAddressZip;
